import { Component, Input, OnInit } from '@angular/core';
import { IceTypes } from '../../models/icetypes';
import { Iceutility } from '../../services/iceutility';
import { IcecontrolSettings } from '../models/icesettings';
import { NotebookObject } from '../models/notebookobject';
import { NotebookPageObject } from '../models/notebookpageobject';

@Component({
  selector: 'icecustomform',
  templateUrl: './icecustomform.component.html',
  styleUrls: ['./icecustomform.component.css']
})
export class IcecustomformComponent implements OnInit {
  @Input() id: string = "";
  @Input() ctrl: IcecontrolSettings = null;

  notebookObject: NotebookObject = null;

  constructor() {

  }

  ngOnInit() {
    if (this.ctrl != null) {
      let frmCtrl = this.ctrl.getFormControl();
      if (frmCtrl == null) return;
      this.notebookObject = <NotebookObject>frmCtrl.value;
      if (this.notebookObject) {
        setTimeout(() => {
          debugger;
          this.notebookObject.initUpdate(this.ctrl, IceTypes.ACCOUNT_TYPE.actNone, "", this.notebookObject.getCurrentPage());
          this.notebookObject.setControlData(this.ctrl, IceTypes.ACCOUNT_TYPE.actNone, "", this.notebookObject.getCurrentPage())
        });
      }
    }
  }
}
